import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';

import { createContainer } from '@dbk-legacy/muster/react';

import Switch from '../../common/switch';

import findIndex from 'lodash/findIndex';
import truncateText from '../../../utils/truncate-text';

import styles from './navigation-bar.styles';
import { Tab, Tabs } from '@dbk/ui-tabs';

class NavigationBar extends PureComponent {
  async onSelectTab(assetNames, i) {
    const {
      replacePage,
      changeStateTitle,
      portfolio: { setAssetClassName },
      search: { clearSearchFilters },
    } = this.props;

    clearSearchFilters();
    changeStateTitle({ custometitle: ' ' });

    const tab = assetNames[ i ].class;

    setAssetClassName(tab);

    await replacePage({ pathname: `/portfolios/${tab}` });

    setTimeout(() => {
      changeStateTitle({ custometitle: '' });
    }, 1000);
  }


  renderTabs(assetNames) {
    return assetNames.map((assetName, i) => {
      return <Tab key={i} testID={`tab_portfolio_navigationBar_test_${i}`} id={`tab_portfolio_navigationBar_test_${i}`} renderLabel={() => assetName.name}></Tab>
    })
  }

  render() {
    const {
      replacePage,
      assetNames,
      portfolio: { assetClassName, setAssetClassName },
      search: { selectedAssetClass },
      messages,
    } = this.props;
    let selectedIndex;
    for (var assetsRow in assetNames) {
      if (assetNames[ assetsRow ].class === 'mmInstruments') {
        assetNames[ assetsRow ].name = 'MM Instruments';
      }
      if (assetNames[ assetsRow ].class === 'fxForwards') {
        assetNames[ assetsRow ].name = 'FX Forwards';
      }
    }
    if (selectedAssetClass !== undefined) {
      selectedIndex = findIndex(assetNames, { class: selectedAssetClass });
      this.props.search.clearSelectedAssetClass();
    } else {
      selectedIndex = findIndex(assetNames, { class: assetClassName });
    }

    return (
      <View style={styles.root}>
        <Tabs
          stretch
          secondary
          handleSelectedIndex={this.onSelectTab.bind(this, assetNames)}
          selectedIndex={selectedIndex}
        >
          {this.renderTabs(assetNames)}
        </Tabs>
      </View>
    );
  }
}

NavigationBar.propTypes = {
  assetNames: PropTypes.arrayOf(
    PropTypes.shape({
      class: PropTypes.string,
      name: PropTypes.string,
    })
  ),
};

export default createContainer({
  $queries: {
    replacePage: { $call: 'ui.history.replace' },
    changeStateTitle: { $call: 'ui.change.customtitle' },
    portfolio: {
      setAssetClassName: { $set: 'assetClassName' },
      assetClassName: true,
    },
    search: {
      selectedAssetClass: true,
      clearSelectedAssetClass: { $call: 'clearSearchSelectedAssetClass' },
      clearSearchFilters: { $call: 'clearFilters' },
    },
  },
})(NavigationBar);
